import "$styles/index.css"

import "./theme.js"
import "./mobile-nav.js"
import "./toc.js"
import "./code-copy.js"
import "./search.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("R2P2-ESP32 Docs is loaded!")
